import "../Styles/MainPage.css";
import "../Styles/checkout.css";

import BasketItem from "../Components/BasketItem";
import { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { HiArrowRight } from "react-icons/hi";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { create_order } from "../store/action/order/order";
import { AiTwotoneDelete } from "react-icons/ai";
import { IoAddCircle } from "react-icons/io5";
import BeatLoader from "react-spinners/BeatLoader";
import OfferModal from "../Components/OfferModal";
import ConfirmDelete from "../Components/ConfirmDelete";
import RemoveMeal from "../Components/RemoveMeal";
import FreeMeal from "../Components/FreeMeal";
import { Frames, CardNumber, ExpiryDate, Cvv } from "frames-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { BackgroundImage } from "react-image-and-background-image-fade";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import { setLanguage } from "../store/action/language/language";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRecommendedProducts,
  fetchPaymentMethod,
  fetchBasket,
} from "../store/action/cart/cart";
import {
  deleteItem,
  clearcart,
  check_offer,
  check_offer_before_create,
} from "../store/action/cart/editCart";

import MoyasarPaymentForm from "../../src/Components/PaymentMoyaserForm";

function Basket() {
  let history = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [products, setProducts] = useState([]);
  const [cartId, setCartId] = useState([]);
  const [total, setTotal] = useState();
  const [calcTotal, setCalcTotal] = useState(false);
  const [currency, setCurrency] = useState("currency");
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState("");
  const [discount, setDiscount] = useState(false);
  const [onlineType, setOnlineType] = useState("checkout");

  const [paymentMethod, setPaymentMethod] = useState({
    paymentMethods: { paymentOnlineType: "checkout" },
  });
  const [cardValid, setCardValid] = useState(false);

  const [code, setCode] = useState("");

  const [discountPrice, setDiscountPrice] = useState(false);
  const [msgEn, setMsgEn] = useState();
  const [msgAr, setMsgAr] = useState();
  const [errorMsgModel, setErrorMsgModel] = useState(false);
  const [modal, setModal] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [removeModal, setRemoveModal] = useState(false);
  const [removeId, setRemoveId] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [freeMealModal, setFreeMealModal] = useState(false);
  const [codeValidating, setCodeValidating] = useState(false);
  const [codeValid, setCodeValid] = useState(null);
  const languageState = useSelector((state) => state.language);
  const [notes, setNotes] = useState("");

  const dispatch = useDispatch();
  const {
    recommendProducts: recommended,
    loading: loadRecommand,
    paymentMethodLoad,
    error,
  } = useSelector((state) => state.cart);
  // const paymentInfo = useSelector((state) => state.cart.paymentMethods);
  const bucket = useSelector((state) => state.cart.bucket) || [];
  const topRef = useRef();
  const cart = useSelector((state) => state.cart.updateCart);

  const paymentRef = useRef();
  const codeRef = useRef();
  const noteRef = useRef();

  useEffect(() => {

    setProducts(bucket || []);
    const savedNotes = localStorage.getItem("notes");
    if (savedNotes) {
      setNotes(savedNotes);
    }
    
    // Check if we're coming back from checkout with an error
    if (location.state?.error) {
      setErrorMsgModel(true);
      setMsgEn(location.state.errorEn || "Unknown error");
      setMsgAr(location.state.errorAr || "خطأ غير معروف");
      setTimeout(() => {
        setErrorMsgModel(false);
        // Clear the error state from location
        history(location.pathname, { replace: true, state: {} });
      }, 3000);
    }
  }, [location]);

  const handleChange = () => {
    const newNotes = noteRef.current.value;
    setNotes(newNotes);
    localStorage.setItem("notes", newNotes);
  };

  useEffect(() => {
    const token = JSON.parse(window.localStorage.getItem("TOKEN"));

    const fetchBasketData = async () => {
      try {
        await dispatch(fetchBasket(token));
        setProducts(bucket || []);
      } catch (error) {
        console.error("Error fetching basket data:", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
    const handleLanguage = () => {
      const data = window.localStorage.getItem("LANGUAGE");
      if (data !== null) {
        const { language, x } = JSON.parse(data);
        i18n.changeLanguage(language);
        document.getElementById("root").style.direction = x;
        dispatch(setLanguage(language, x));
      }
      document.title =
        i18n.language === "ar" ? "مطاعم الرومانسية" : "Al Romansiah Restaurant";
    };
    fetchBasketData();
    handleLanguage();
  }, [dispatch, cart, loadRecommand]);
  useEffect(() => {
    localStorage.removeItem("cardToken");
  }, []);

  const totalPrice = (bucket || []).reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );













  function handleMinPriceError(response) {
    setErrorMsgModel(true);
    setMsgEn(
      "Order total price must be at least " + response.data.data.minPrice + " "
    );
    setMsgAr("الحد الأدنى للطلب " + response.data.data.minPrice + " ");
    setSubmitLoading(false);

    setTimeout(function () {
      setErrorMsgModel(false);
    }, 2000);
  }

  //on clicking cleart cart and confirimg in ConfirmDelete modal
  //Clear_cart api call takes cart id and user token
  function clearCart() {
    const token = window.localStorage.getItem("TOKEN");
    dispatch(clearcart(cartId, JSON.parse(token)));
    if (!error) {
      localStorage.removeItem("cardToken");
      setProducts([]);

      setLoading(false);
      history("/menu/meals");
    }
  }


  //on clicking delete button in BasketItem component and confirming delete in RemoveMeal modal
  //Delete_Item api call takes cart id, meal id and and user token
  //meal id was sotred when user clicks on  delete button in BasketItem component
  function handleClose() {

    const token = window.localStorage.getItem("TOKEN");
    dispatch(deleteItem(cartId, removeId, JSON.parse(token)));
    setLoading(false);
    if (!error) {
      setProducts(products.filter((data) => data.id != removeId)); //set product list array to all items except that of deleted id
      setCalcTotal(!calcTotal);
      setLoading(false);
    }
  }
  async function checkOfferAndCreateOrder(
    data2,
    token,
    data,
    handleCheckOfferError
  ) {
    // localStorage.setItem("notes", "");

    try {
      console.log("🔄 [Basket] Creating order...", { data, token: token ? "token exists" : "no token" });
      
      // Token should be a string from localStorage, parse it
      const parsedToken = typeof token === 'string' ? JSON.parse(token) : token;
      console.log("📞 [Basket] Calling check_offer API...");
      const response = await check_offer(data, parsedToken); // ✅ Wait for response
      
      console.log("✅ [Basket] Order API response:", response);

      // Check if the response indicates a failure (even with 200 status)
      if (response.data?.message === "failed" || response.data?.error) {
        console.log("⚠️ [Basket] Response indicates failure:", response.data);
        
        const errorEn = 
          response.data?.error || 
          response.data?.errorEn || 
          response.data?.data?.error ||
          "Unknown error";
          
        const errorAr = 
          response.data?.errorAr || 
          response.data?.error_ar ||
          response.data?.data?.errorAr ||
          response.data?.data?.error_ar ||
          errorEn; // Fallback to English if Arabic not available
        
        console.log("📝 [Basket] Extracted error from response:", { errorEn, errorAr });
        
        setErrorMsgModel(true);
        setMsgEn(errorEn);
        setMsgAr(errorAr);
        setSubmitLoading(false);
        localStorage.removeItem("notes");

        // Don't navigate, just show the error message
        setTimeout(() => {
          setErrorMsgModel(false);
        }, 3000);

        // Throw an error to prevent further processing
        throw new Error(errorEn);
      }

      await handleOrderCreationResponse(response); // ✅ Wait for redirection
      localStorage.removeItem("notes")

      return response; // ✅ Return response so `checkOffer` can use it
    } catch (error) {
      console.error("❌ [Basket] Order creation error:", error);
      console.error("❌ [Basket] Error response:", error.response);
      console.error("❌ [Basket] Error response data:", error.response?.data);
      
      setErrorMsgModel(true);
      
      // Try multiple possible error message locations
      const errorEn = 
        error.response?.data?.error || 
        error.response?.data?.errorEn || 
        error.response?.data?.message ||
        error.response?.data?.data?.error ||
        error.message || 
        "Unknown error";
        
      const errorAr = 
        error.response?.data?.errorAr || 
        error.response?.data?.error_ar ||
        error.response?.data?.data?.errorAr ||
        error.response?.data?.data?.error_ar ||
        errorEn; // Fallback to English if Arabic not available
      
      console.log("📝 [Basket] Extracted error messages:", { errorEn, errorAr });
      
      setMsgEn(errorEn);
      setMsgAr(errorAr);
      setSubmitLoading(false);
      localStorage.removeItem("notes")

      setTimeout(() => {
        setErrorMsgModel(false);
      }, 3000);

      throw error; // ✅ Propagate error to caller
    }
  }

  function handleCheckOfferError(error) {
    // Handle the error here
    setLoading(false);
    setSubmitLoading(false);
    setErrorMsgModel(true);
    setMsgEn(error.response.data.error);
    setTimeout(() => {
      setErrorMsgModel(false);
    }, 5000);
  }

  async function validateCouponCode() {
    if (!code || code.trim() === "") {
      setErrorMsgModel(true);
      setMsgEn("Please enter a coupon code");
      setMsgAr("يرجى إدخال كود الترويج");
      setTimeout(() => {
        setErrorMsgModel(false);
      }, 2000);
      return;
    }

    setCodeValidating(true);
    setCodeValid(null);
    const token = window.localStorage.getItem("TOKEN");
    const typeId = window.localStorage.getItem("typeId");

    const data = {
      payment: selectedOption,
      code: code,
      typeId: typeId,
      token: null,
    };

    try {
      const response = await check_offer_before_create(data, JSON.parse(token));
      setCodeValid(true);
      setErrorMsgModel(true);
      setMsgEn("Coupon code is valid!");
      setMsgAr("كود الترويج صحيح!");
      setTimeout(() => {
        setErrorMsgModel(false);
      }, 2000);
    } catch (error) {
      setCodeValid(false);
      setErrorMsgModel(true);

      // Handle unauthenticated guests with a clearer message
      const backendError = error?.response?.data?.error;
      if (backendError === "Unauthenticated.") {
        setMsgEn("You must log in first to enter a promo code.");
        setMsgAr("يجب تسجيل الدخول أولاً لإدخال كود الترويج.");
        // Clear the code when user is not authenticated
        setCode("");
        localStorage.removeItem("code");
        if (codeRef.current) {
          codeRef.current.value = "";
        }
      } else {
        setMsgEn(backendError || "Invalid coupon code");
        setMsgAr(
          error?.response?.data?.errorAr ||
            backendError ||
            "كود الترويج غير صحيح"
        );
      }

      setTimeout(() => {
        setErrorMsgModel(false);
      }, 3000);
    } finally {
      setCodeValidating(false);
    }
  }
  function handleOrderCreationResponse(response) {
    console.log("here is the res");
    console.log(response.data.data);
    
    // Check if the response indicates a failure before proceeding
    if (response.data?.message === "failed" || response.data?.error) {
      // Don't navigate or process the order if it failed
      // Clear any stale order data
      localStorage.removeItem("orderId");
      localStorage.removeItem("orderIdTimestamp");
      localStorage.removeItem("sk");
      localStorage.removeItem("orderQueueId");
      return;
    }
    
    // Validate that we have the required data
    if (!response.data?.data?.orderId || !response.data?.data?.sk) {
      console.error("Missing required order data:", response.data);
      // Clear any stale order data
      localStorage.removeItem("orderId");
      localStorage.removeItem("orderIdTimestamp");
      localStorage.removeItem("sk");
      localStorage.removeItem("orderQueueId");
      return;
    }
    
    localStorage.removeItem("notes")

    // CRITICAL: Clear old order data before setting new order
    // This prevents mixing old and new order data (fixes race condition)
    localStorage.removeItem("orderId");
    localStorage.removeItem("orderIdTimestamp");
    localStorage.removeItem("sk");
    localStorage.removeItem("orderQueueId");
    
    localStorage.removeItem("cardToken");
    
    // Set new order data with timestamp for validation
    localStorage.setItem("orderId", response.data.data.orderId);
    localStorage.setItem("orderIdTimestamp", Date.now().toString()); // CRITICAL: Add timestamp
    localStorage.setItem("orderQueueId", response.data.data.orderQueueId);
    
    // Save sk for Moyasar payment
    if (response.data.data.sk) {
      localStorage.setItem("sk", response.data.data.sk);
    }

    //to remove
    const paymentMethod = process.env.REACT_APP_PAYMENT_METHOD;

    if (paymentMethod != "moyasar")
      window.location.href = response.data.data.url;

    // Only remove cart if not using Moyasar (for Moyasar, keep cart until payment is confirmed)
    if (paymentMethod != "moyasar") {
      localStorage.removeItem("cart");
    }
  }

  async function checkOffer(cardToken) {
    const token = window.localStorage.getItem("TOKEN");
    setSubmitLoading(true);

    const typeId = window.localStorage.getItem("typeId");
    const tableId = window.localStorage.getItem("tableId");

    const data = {
      payment: selectedOption,
      code: codeRef.current?.value || "",
      typeId: typeId,
      token: cardToken || null, // Avoid storing an undefined token
    };

    const data2 = createData2(cardToken || null, typeId, tableId, data);

    window.localStorage.setItem("ORDER", JSON.stringify(data2));

    return await checkOfferAndCreateOrder(
      data2,
      token,
      data,
      handleCheckOfferError
    );
  }
  function createData2(cardToken, typeId, tableId, data) {
    const baseData = {
      token: selectedOption === "checkout" ? cardToken : "",
      remainPaymentMethod: null,
      payment: selectedOption,
      code: codeRef.current.value,
      notes: noteRef.current.value,
    };

    if (typeId === 5) {
      return {
        ...baseData,
        tableId: tableId,
      };
    } else {
      return {
        ...baseData,
        tableId: "",
      };
    }
  }


  return (
    <div dir={i18n.language != "ar" ? 'rtl' : 'ltr'} >
      {modal ? (
        <OfferModal
          setModal={setModal}
          checkOffer={checkOffer}
          totalPrice={discountPrice}
          price={total}
        />
      ) : null}
      {freeMealModal ? (
        <FreeMeal
          setModal={setFreeMealModal}
          totalPrice={discountPrice}
          price={total}
          onHandleContinue={() => setModal(false)}
        />
      ) : null}
      {
        delModal ? (
          <ConfirmDelete
            setLoading={setLoading}
            setModal={setDelModal}
            clearCart={clearCart}
          />
        ) : null
      }
      {removeModal ? (
        <RemoveMeal
          setLoading={setLoading}
          handleCls={handleClose}
          setModal={setRemoveModal}
        />
      ) : null}
      <div className="Basket ">
        {loading ? (
          <div className="loader">
            <BeatLoader color={"#E57200"} loading={loading} size={30} />
          </div>
        ) : (
          <div>



            <div
              className="  container"
              style={
                products.length == 0 || recommended.length == 0
                  ? null
                  : { overflow: "hidden" }
              }
            >
              <div ref={topRef} className="bTop">
               
                {!products.length == 0 ? (
                  <p
                    style={
                      i18n.language == "ar" || i18n.language == "ur"
                        ? { textAlign: "right" }
                        : { textAlign: "left" }
                    }
                  >
                    {" "}
                    {t("Basket.title")}
                  </p>
                ) : null}

                <Link to="/menu/meals">
                  {" "}
                  <button
                    style={{ width: "50px", height: "50px" }}
                    className={

                      languageState.lang == "en" || languageState.lang == "id"
                        ? "ciBackbtn bck flex flex-row justify-center items-center"
                        : "bck flex flex-row justify-center items-center"
                    }
                  >
                    <HiArrowRight size={25} className="text-black" />
                  </button>
                </Link>
              </div>

              {products.length == 0 || recommended.length == 0 ? null : (
                <div className="spRecomend">
                  <p> {t("Single_product.recommended")}</p>
                  <Swiper
                    navigation={true}
                    dir={
                      i18n.language == "ar" || i18n.language == "ur"
                        ? "rtl"
                        : "ltr"
                    }
                    key={i18n.language}
                    slidesPerView={"auto"}
                    spaceBetween={20}
                    modules={[Navigation]}
                    className={
                      i18n.language == "ar" || i18n.language == "ur"
                        ? "recommendSlider recommmendAr"
                        : "recommendSlider recommmendEn"
                    }
                  >
                    {recommended &&
                      recommended.map((data, index) => (
                        <SwiperSlide key={index}>
                          <div
                            style={{
                              margin: "0.5em 0",
                              paddingBottom: "1em",
                              cursor: "pointer",
                            }}
                            onClick={() => history(`/meals/${data.id}`)}
                          >
                            <div className=" medyafMenu reccomendation recommendBasket">
                              <BackgroundImage
                                src={data.image}
                                width="100%"
                                style={{
                                  borderRadius: "8px 8px 0 0",
                                  maxHeight: "160px",
                                }}
                                className="bckg"
                              />

                              <div style={{ padding: "0.3em" }}>
                                <p className="recommend-name">
                                  {" "}
                                  {data.name && data.name}
                                </p>
                                <p className="recommend-price">
                                  {data.price}{" "}
                                  {localStorage.getItem("countryId") === "1"
                                    ? t("Currency")
                                    : t("CurrencyBH")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              )}
            </div>

            <div className="  container">
              <div className="row">
                {bucket && bucket.map((data, index) => {
                  return (
                    <BasketItem
                      setModal={setRemoveModal}
                      setRemoveId={setRemoveId}
                      setLoading={setLoading}
                      key={index}
                      cartId={cartId}
                      mealId={data.productId}
                      unitPrice={data.price}
                      name={data != null ? data.name : "not found"}
                      image={data.image}
                      description={i18n.language == "ar" ? data.arDescription : data.enDescription}
                      quantity={data.quantity}
                      calcTotal={calcTotal}
                      setCalcTotal={setCalcTotal}
                      currency={
                        localStorage.getItem("countryId") === "1"
                          ? <span className="icon-saudi_riyal"></span>
                          : t("CurrencyBH")
                      }
                    />
                  );
                })}
                {/* products.map((data)=>{
       <BasketItem handleCls={handleClose}/>
       <BasketItem quan={10} subtract={handleSub} add={handleAdd}/>
     })*/}
              </div>
              <div className="bDiv2">
                {!products.length == 0 ? (
                  <div
                    className={
                      languageState.lang == "en" || languageState.lang == "id"
                        ? " enbNote"
                        : "bNote"
                    }
                  >
                    <form style={{ position: "relative" }}>
                      <p> {t("Basket.input1")}</p>
                      {/*<input type="text" placeholder='....اضف ملاحظاتك هنا &#160; &#xf4ad;'></input>
                       */}
                      <label htmlFor="note"> </label>
                      <input
                        onChange={(e) => {
                          JSON.stringify(
                            localStorage.setItem("notes", e.target.value)
                          );
                          setNotes(e.target.value);
                        }}
                        type="text"
                        name="note"
                        placeholder={t("Basket.input2")}
                        ref={noteRef}
                        value={notes}
                      ></input>

                      <div className="promoCode">
                        <p> {t("Basket.code")}</p>
                        <label htmlFor="code"> </label>
                        <div className="promoCodeInputWrapper">
                          <input
                            onChange={(e) => {
                              JSON.stringify(
                                localStorage.setItem("code", e.target.value)
                              );
                              setCode(e.target.value);
                              setCodeValid(null);
                            }}
                            type="text"
                            value={code}
                            id="code"
                            name="code"
                            placeholder={t("Basket.enter_code")}
                            ref={codeRef}
                            className={codeValid === true ? "codeValid" : codeValid === false ? "codeInvalid" : ""}
                          ></input>
                          <span
                            className={`promoCodeCheckText ${!code || code.trim() === "" ? "empty" : "active"}`}
                            onClick={codeValidating || !code || code.trim() === "" ? undefined : validateCouponCode}
                            style={{ cursor: codeValidating || !code || code.trim() === "" ? "not-allowed" : "pointer" }}
                          >
                            {codeValidating ? (
                              <BeatLoader color={"#E57200"} loading={true} size={5} />
                            ) : (
                              t("Basket.apply")
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="paymentTYpe">
                        <p> {t("Basket.payment")}</p>
                        <div
                          style={
                            i18n.language == "en" || languageState.lang == "id"
                              ? { direction: "rtl" }
                              : null
                          }
                          className="row"
                        >
                          <div
                            style={{ justifyContent: "end" }}
                            className="col-sm  tapChoice"
                          >
                            <label>{t("Basket.credit")}</label>
                            {onlineType == "tap" ? (
                              <input
                                type="radio"
                                value="tap"
                                checked={onlineType === "tap"}
                                onChange={() => setOnlineType("tap")}
                                name="payment"
                                id="tap"
                              ></input>
                            ) : (
                              <input
                                type="radio"
                                value="checkout"
                                checked={onlineType === "checkout"}
                                onChange={() => setOnlineType("checkout")}
                                name="payment"
                                id="tap"
                              ></input>
                            )}
                          </div>
                        </div>

                        <div></div>
                        {false ? (
                          <MoyasarPaymentForm
                            amount={totalPrice}

                          />
                        ) : null}
                      </div>

                      <div
                        className={
                          errorMsgModel
                            ? "addAlert errAlert"
                            : " addAlert alert-hidden errAlert"
                        }
                      >
                        <div className="row">
                          <div className="col">
                            <div
                              className={
                                i18n.language == "ar" || i18n.language == "ur"
                                  ? "vAlignText"
                                  : "vAlignText enAlert"
                              }
                            >
                              <span className="err">
                                {languageState.lang == "en" ? msgEn : msgAr}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                ) : (
                  <div className="bEmpty">
                    <p>{t("Basket.empty")}</p>
                    <Link to="/menu/meals">
                      <button>
                        {t("Basket.add")}&#160;
                        <IoAddCircle />
                      </button>
                    </Link>
                  </div>
                )}
              </div>
            </div>

            {!products.length == 0 && onlineType == "checkout" ? (
              <div className="stickyBottomContainer">
                <div className="stickyBottomContent">
                  <button
                    id="pay-button"
                    className="stickyContinueButton"
                    onClick={async () => {
                      const tokenString = window.localStorage.getItem("TOKEN");
                      const token = JSON.parse(tokenString);
                      const isGuest = token === "token";
                      // Only pass code if it was successfully validated AND user is authenticated
                      const codeToPass = (codeValid === true && !isGuest) ? codeRef.current?.value || "" : "";
                      
                      // For guest mode, validate order creation before navigating
                      if (isGuest) {
                        setSubmitLoading(true);
                        try {
                          const typeId = window.localStorage.getItem("typeId");
                          const tableId = window.localStorage.getItem("tableId");
                          
                          const data = {
                            payment: selectedOption,
                            code: codeToPass,
                            typeId: typeId,
                            token: null,
                          };
                          
                          const data2 = createData2(null, typeId, tableId, data);
                          window.localStorage.setItem("ORDER", JSON.stringify(data2));
                          
                          // Try to create order first (this will fail fast if there's an issue)
                          // Pass the raw token string, not the parsed value
                          await checkOfferAndCreateOrder(
                            data2,
                            tokenString, // Pass raw string so it can be parsed inside the function
                            data,
                            handleCheckOfferError
                          );
                          
                          // Only navigate if order creation succeeds
                          history("/checkOut", { state: { code: codeToPass } });
                        } catch (error) {
                          // Error is already handled in checkOfferAndCreateOrder
                          // Don't navigate, just show error in basket
                          setSubmitLoading(false);
                        }
                      } else {
                        // For authenticated users, just navigate (order will be created in Checkout with payment token)
                        history("/checkOut", { state: { code: codeToPass } });
                      }
                    }}
                    disabled={submitLoading}
                  >
                    {submitLoading ? (
                      <BeatLoader color={"#fff"} loading={true} size={8} />
                    ) : (
                      t("Basket.button")
                    )}
                  </button>
                  <div className="stickyTotalPrice">
                    <p className="stickyTotalLabel">
                      {t("Invoice.total_price")}
                    </p>
                    <p className="stickyTotalAmount">
                      {totalPrice}{" "}
                      {localStorage.getItem("countryId") === "1"
                        ? <span className="icon-saudi_riyal"></span>
                        : t("CurrencyBH")}
                    </p>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
export default Basket;

//tap payment
/*
var style = {
  base: {
    color: '#535353',
    lineHeight: '18px',
    fontFamily: 'sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: 'rgba(0, 0, 0, 0.26)',
      fontSize:'15px'
    }
  },
  invalid: {
    color: 'red'
  }
};
// input labels/placeholders
var labels = {
    cardNumber:"Card Number",
    expirationDate:"MM/YY",
    cvv:"CVV",
    cardHolder:"Card Holder Name"
  };
//payment options
var paymentOptions = {
  currencyCode:["KWD","USD","SAR"],
  labels : labels,
  TextDirection:'ltr'
}
//create element, pass style and payment options
var card = elements.create('card', {style: style},paymentOptions);
//mount element
card.mount('#element-container');
//card change event listener
card.addEventListener('change', function(event) {
  if(event.BIN){
    console.log(event.BIN)
  }
  if(event.loaded){
    console.log("UI loaded :"+event.loaded);
    console.log("current currency is :"+card.getCurrency())
  }
  var displayError = document.getElementById('error-handler');
  if (event.error) {
    displayError.textContent = event.error.message;
  } else {
    displayError.textContent = '';
  }
});

// Handle form submission
var form = document.getElementById('form-container');
form.addEventListener('submit', function(event) {
  event.preventDefault();

  tap.createToken(card).then(function(result) {
    console.log(result);
    if (result.error) {
      // Inform the user if there was an error
      var errorElement = document.getElementById('error-handler');
      errorElement.textContent = result.error.message;
    } else {
      // Send the token to your server
      var errorElement = document.getElementById('success');
      errorElement.style.display = "block";
      var tokenElement = document.getElementById('token');
      tokenElement.textContent = result.id;
      console.log(result.id);
    }
  });
});*/
